import { useTranslation } from 'react-i18next';
import { countAttentionItems } from '@/api/attention/attentionApi.types';
import { AssistantTargetRegion } from '@/components/assistant/uiActions/AssistantTargetRegion';
import { ASSISTANT_TARGET_KEY } from '@/components/assistant/uiActions/assistantTargetKeys';
import { Icon } from '@/components/common/Icon';
import { AttentionSections } from '@/components/practitioner/shared/AttentionSections';
import { Card } from '@/components/ui/card';
import { useWorkspaceAttentionQuery } from '@/hooks/useWorkspaceAttentionQuery';

interface NeedsAttentionCardProps {
  className?: string;
}

export function NeedsAttentionCard({ className }: NeedsAttentionCardProps) {
  const { t } = useTranslation('dashboard');
  const attentionQuery = useWorkspaceAttentionQuery(null);
  const attention = attentionQuery.data;

  if (attention === undefined || countAttentionItems(attention) === 0) {
    return null;
  }

  return (
    <AssistantTargetRegion
      targetKey={ASSISTANT_TARGET_KEY.dashboardNeedsAttention}
      className={className}
    >
      <Card as="section" padding="sm">
        <div className="flex items-center gap-2">
          <span className="w-8 h-8 rounded-lg bg-zoowarningbg text-zoowarningtext flex items-center justify-center shrink-0">
            <Icon name="Bell" />
          </span>
          <h2 className="text-base font-bold text-zooindigo flex-1 min-w-0">
            {t('attention.title')}
          </h2>
          <span className="min-w-[24px] h-6 px-2 flex items-center justify-center rounded-full bg-zoowarningbg text-zoowarningtext text-xs font-bold shrink-0">
            {countAttentionItems(attention)}
          </span>
        </div>
        <p className="text-xs text-zoomuted mt-1 mb-4">{t('attention.subtitle')}</p>
        <AttentionSections attention={attention} isScopedToClient={false} />
      </Card>
    </AssistantTargetRegion>
  );
}
